import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'KenRp01 | バックエンドエンジニア',
  lang: 'ja',
  description:
    'Java・Spring Bootを中心に、Webアプリケーションの設計と開発に取り組むバックエンドエンジニアKenRp01のポートフォリオです。',
};

// HERO DATA
export const heroData = {
  title: 'こんにちは、',
  name: 'KenRp01',
  subtitle: 'バックエンドエンジニアです。',
  cta: 'プロフィールを見る',
  blogCta: 'KenRp Blog',
  blogUrl: 'https://kenrp01.github.io/kenRp-blog/',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile_bike.jpg',
  paragraphOne:
    'Java・Spring Bootを中心に、WebアプリケーションやバックエンドAPIの設計・開発に取り組むエンジニアです。要件定義から運用保守まで一貫して経験し、GoやReact・TypeScriptを使った開発にも対応しています。',
  paragraphTwo:
    'レガシーシステムの刷新、性能改善、CI/CD・テスト自動化、監視・可観測性の改善を得意としています。PM・PLとして案件推進や関係者調整も経験しており、技術とプロジェクト推進の両面から、システムの品質と開発生産性の向上に取り組んでいます。',
  resume: 'https://qiita.com/kenRp01', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'go:reactChat.png',
    title: 'Go + React Chat',
    info:
      'GoによるREST APIとReactによる画面を組み合わせ、チャット機能のデータフローを検証した個人開発です。',
    info2: 'APIとUIを分離し、異なる言語・実行環境間で型と責務をどう整理するかを学びました。',
    role: '企画、API設計、フロントエンド・バックエンド実装',
    technologies: 'Go、Echo、React、TypeScript',
    outcome: 'REST APIの設計から画面接続まで、一連の実装を通して構成上の判断点を整理しました。',
    url: 'https://react-todo-app-five-silk.vercel.app/',
    repo: 'https://github.com/kenRp01/react-todo-app', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'angularChat.jpg',
    title: 'AngularChat',
    info:
      'AngularとFirebaseの学習を目的に、メッセージを投稿・参照できるチャットアプリを開発しました。',
    info2: 'コンポーネント分割、フォーム、Firebaseを使ったデータ永続化を実装しています。',
    role: '画面設計、フロントエンド実装、Firebase設定',
    technologies: 'Angular、TypeScript、Firebase',
    outcome: 'CRUD処理とリアルタイムデータを扱うWebアプリケーションの基本構成を習得しました。',
    url: 'https://angular-chat-dcc8f.web.app/',
    repo: 'https://github.com/kenRp01/angular-chat', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'todo-app.jpg',
    title: 'todo-app',
    info: 'Angularの状態管理とコンポーネント間連携を学ぶために作成したToDoアプリです。',
    info2:
      'タスクの追加・更新・削除という小さなドメインに絞り、画面とロジックの責務分離を試しました。',
    role: '画面設計、フロントエンド実装',
    technologies: 'Angular、TypeScript、Firebase Hosting',
    outcome: '基本的なCRUD操作を一貫したUIで提供し、Angularの開発サイクルを確認しました。',
    url: 'https://todo-demo-app-angular-68704.web.app/',
    repo: 'https://github.com/kenRp01/todo-app', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'KenRp Blog',
    info:
      'GatsbyとMarkdownで運用している個人技術ブログです。日々の実装メモを、後から読み返せる記事として整理しています。',
    info2:
      'frontmatter契約、draft制御、タグ・カテゴリ導線、GitHub Pages配信、Mermaid図表の表示を整備しました。',
    role: 'サイト設計、Markdown運用設計、Gatsby実装、GitHub Pages公開',
    technologies: 'Gatsby、React、Markdown、Playwright、GitHub Pages',
    outcome:
      '技術メモを公開記事へ変換する流れを作り、記事一覧・詳細・問い合わせ・図表表示までブログとして利用できる状態にしました。',
    url: 'https://kenrp01.github.io/kenRp-blog/',
    repo: 'https://github.com/kenRp01/kenRp-blog',
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'ShareShopi',
    info:
      '共有買い物リストを題材に、招待リンク、リスト共有、モバイルUI、認証・データ移行を検証しているWebアプリです。',
    info2:
      'Next.js App Routerを中心に、Firebase Auth、Cloudflare D1、OpenNext for Cloudflareへの移行を進めています。',
    role: 'プロダクト設計、UI改善、API設計、認証・データ移行、テスト整備',
    technologies: 'Next.js、React、TypeScript、Firebase Auth、Cloudflare D1、Playwright',
    outcome:
      '共有アプリのUI、API、認証、データ永続化を分けて整理し、Cloudflare上で運用しやすい構成へ近づけました。',
    url: 'https://app.shareshopi.workers.dev',
    repo: 'https://github.com/kenRp01/shared-shopping-app',
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'daytrade_10-30man',
    info:
      '日々の売買判断を小さく検証するための、利益計算・入力UI・確認フローを備えた個人開発ツールです。',
    info2:
      '計算ロジックと画面表示を分け、ブラウザ確認とテストで小さな変更を安全に積み上げる構成を試しました。',
    role: '要件整理、計算ロジック実装、UI実装、テスト・ブラウザ確認',
    technologies: 'React、JavaScript、Playwright',
    outcome:
      '数値入力と結果表示の責務を分離し、投資・日次確認系ツールで必要になる検証観点を整理しました。',
    url: 'https://kenrp01.github.io/kenRp-blog/2026-06-28-weekly-knowledge/',
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'kakei-balance-app',
    info:
      'MONE MILとして作成している、低コスト運用前提の家計バランスアプリです。ゲスト利用から家計共有まで段階的に扱えます。',
    info2:
      'IndexedDBでのローカル保存、Supabase Auth、共有招待、レシートOCR、PayPay履歴スクショOCRを組み合わせています。',
    role: '要件整理、画面設計、家計集計ロジック、認証・共有設計、OCR導入',
    technologies: 'Next.js、React、Supabase、IndexedDB、Tesseract.js、Zod',
    outcome:
      'ログイン不要のMVPを壊さず、認証ユーザー向けのクラウド保存と家計共有へ拡張できる構成を整理しました。',
    repo: 'https://github.com/kenRp01/kakei-balance-app',
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'handmade-profit-calculator',
    info:
      'CraftMarginとして作成している、ハンドメイド作家向けの利益・損益分岐価格・おすすめ価格計算ツールです。',
    info2:
      '材料費、送料、梱包費、販売手数料を入力し、保存件数制限や有料版検証フラグも含めて需要検証できる構成にしています。',
    role: 'プロダクト設計、計算ロジック実装、UI実装、Cloudflare Pages公開設計',
    technologies: 'React、Vite、Zod、Playwright、Cloudflare Pages',
    outcome:
      '販売手数料と原価計算をクライアントサイドで扱い、小さく公開して需要検証へ進める状態を作りました。',
    url: 'https://handmade-profit-calculator.pages.dev/',
    repo: 'https://github.com/kenRp01/handmade-profit-calculator',
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'product-service',
    info:
      'Spring Bootで作成した商品管理向けのマイクロサービスです。MongoDBを使ったデータ永続化とREST APIを扱います。',
    info2:
      'Testcontainers、REST Assured、Springdoc OpenAPIを導入し、APIの検証と仕様確認をしやすい構成にしています。',
    role: 'API設計、バックエンド実装、テスト基盤整備、OpenAPI導入',
    technologies: 'Java 21、Spring Boot、MongoDB、Testcontainers、REST Assured、Springdoc',
    outcome:
      '商品サービスの基本的なAPI構成を作り、Swagger UIとAPI Docsで確認できるバックエンドの土台を用意しました。',
    repo: 'https://github.com/kenRp01/product-service',
  },
  {
    id: nanoid(),
    img: 'login-app.jpg',
    title: 'login-app',
    info:
      '社内のエンジニアにAngularを用いた開発を体験してもらうために簡易的に作成したログイン画面。AngularMaterialの学習にもなった。',
    info2: 'https://qiita.com/kenRp01/items/bc42fa1cdc766b75f842',
    role: '教材設計、画面設計、フロントエンド実装、解説記事作成',
    technologies: 'Angular、TypeScript、Angular Material',
    outcome:
      '社内エンジニアがAngular開発を体験できる題材として実装し、学習内容を記事にまとめました。',
    url: 'https://login-app-c2794.web.app/login',
    repo: 'https://github.com/kenRp01/login-app', // if no repo, the button will not show up
  },
];

// BLOG DATA
export const blogData = {
  title: 'KenRp Blog',
  description:
    '実装で試したこと、判断の理由、あとから見返したい技術メモを記事として整理しています。Java、Spring Boot、フロントエンド、Cloudflare、Codexを使った開発運用などを扱います。',
  url: 'https://kenrp01.github.io/kenRp-blog/',
  articles: [
    {
      id: nanoid(),
      title: 'ShareShopiのCloudflare移行を再現できる技術記録にする',
      summary:
        '移行作業で確認した構成、検証観点、詰まりやすい判断点を、あとから再現できる形でまとめた記事です。',
      url: 'https://kenrp01.github.io/kenRp-blog/2026-07-05-weekly-knowledge/',
    },
    {
      id: nanoid(),
      title: '実装ログを公開できる技術記録へ変換する運用',
      summary:
        '日々の作業ログをそのまま残すのではなく、読める技術記事へ変換するための整理方法をまとめています。',
      url: 'https://kenrp01.github.io/kenRp-blog/2026-06-28-weekly-knowledge/',
    },
    {
      id: nanoid(),
      title: '小さな改修を公開可能な技術知見へ変える進め方',
      summary:
        '小さな修正から得た学びを、再利用できる知識として記事化するための視点を整理しています。',
      url: 'https://kenrp01.github.io/kenRp-blog/2026-06-21-weekly-knowledge/',
    },
  ],
};

// CONTACT DATA
export const contactData = {
  cta: '開発や技術発信についてのご連絡はこちらからお願いします。',
  btn: 'メールを送る',
  email: 'kinema@digdig.org',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'search',
      url: 'https://qiita.com/kenRp01',
    },
    // {
    //   id: nanoid(),
    //   name: 'linkedin',
    //   url: '',
    // },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/kenRp01',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: true, // set to false to disable the GitHub stars/fork buttons
};
